import { jsx as baseJsx, jsxs as baseJsxs } from "react/jsx-runtime";
import { LocalizedHost, linkProps } from "./host";
export { Fragment } from "react/jsx-runtime";
export namespace JSX {
  export type Element = React.JSX.Element;
  export type ElementType = React.JSX.ElementType;
  export type ElementChildrenAttribute = React.JSX.ElementChildrenAttribute;
  export type IntrinsicElements = React.JSX.IntrinsicElements;
  export type IntrinsicAttributes = React.JSX.IntrinsicAttributes;
  export type LibraryManagedAttributes<C, P> = React.JSX.LibraryManagedAttributes<C, P>;
}
export const jsx: typeof baseJsx = (type, props, key) => typeof type === "string"
  ? baseJsx(LocalizedHost, { tag: type, originalProps: props, ref: (props as Record<string, unknown>).ref }, key)
  : baseJsx(type, linkProps(type, props), key);
export const jsxs: typeof baseJsxs = (type, props, key) => typeof type === "string"
  ? baseJsxs(LocalizedHost, { tag: type, originalProps: props, ref: (props as Record<string, unknown>).ref }, key)
  : baseJsxs(type, linkProps(type, props), key);
